import type { Product } from '../pages/CatalogPage';
import type { Country } from '../types';

// Helper function to get visible countries (countries with at least one true or "Coming Soon" value)
export const getVisibleCountries = (products: Product[], countries: Country[]) => {
  return countries.filter(country =>
    products.some(
      product =>
        product.countries[country.code] === true ||
        product.countries[country.code] === 'Coming Soon'
    )
  );
};

// Helper function to check if a country has any "Coming Soon" values
export const hasComingSoonForCountry = (products: Product[], countryCode: string): boolean => {
  return products.some(product => product.countries[countryCode] === 'Coming Soon');
};

// Helper function to count how many countries a product is available in (true values only)
export const countCountryAvailability = (product: Product) => {
  return Object.values(product.countries).filter(value => value === true).length;
};

// Helper function to sort products by country availability (most available first), then alphabetically
export const sortByAvailability = (products: Product[]) => {
  return [...products].sort((a, b) => {
    const countA = countCountryAvailability(a);
    const countB = countCountryAvailability(b);

    // Sort by country availability (descending - most available first)
    if (countA !== countB) {
      return countB - countA;
    }

    // If same availability, sort alphabetically by solution name
    return a.solution.localeCompare(b.solution);
  });
};
